import React from "react";
import { useTranslation } from "react-i18next";
import PasswordGate from "components/PasswordGate/PasswordGate.js";
import ServicePage from "./ServicePage.js";

// Keeps the gate's copy out of routes.js and out of ServicePage: the page does
// not know it is gated, and the gate does not know what it is covering. A
// service without a `gate` renders straight through, so adding an unlisted page
// that is merely unlinked rather than gated needs no change here.
function GatedService({ service }) {
  const { t } = useTranslation();
  const page = <ServicePage serviceKey={service.key} />;

  if (!service.gate) return page;

  return (
    <PasswordGate
      gateId={service.gate.id}
      secret={service.gate.secret}
      title={t("gate.title")}
      prompt={t("gate.prompt")}
      label={t("gate.label")}
      submitLabel={t("gate.submit")}
      errorText={t("gate.error")}
    >
      {page}
    </PasswordGate>
  );
}

export default GatedService;
